import { DataTypes as DT } from 'business/definitions';
import { FILTER_CONNECTOR } from 'modules/decision/constants';

export const dummyMetric: SentenceMetricT = {
    field: '',
    displayIndex: 0,
    aggregation: 'sum',
    functions: [],
    type: DT.float,
};

export const getDummyDimension = (
    displayIndex: number,
    isFirst: boolean,
): SentenceDimensionT => ({
    displayIndex,
    isFirst,
    field: '',
    type: 'float',
    isTree: false,
    aggregationStrategy: null,
});

export const getDummyFilter = (): SentenceFilterT => ({
    type: DT.integer,
    operation: 'greater_or_equal',
    value: '',
    values: [],
    displayIndex: 0,
    field: '',
    isNew: true,
});

export const initialSentenceState: SentenceQueryT = {
    metrics: [dummyMetric],
    dimensions: [],
    filters: { connector: FILTER_CONNECTOR.and, children: [] },
};
